import React from "react";
import Popup from "reactjs-popup";
import recipebook from "../assets/images/popup/meal-recipe.png";
import custommeal from "../assets/images/popup/custom-meal.png";
import { Link } from "react-router-dom";

const MealLogPopup = ({ isMealLogOpen, setIsMealLogOpen }) => {
  return (
    <Popup
      open={isMealLogOpen}
      onClose={() => {
        setIsMealLogOpen(false);
      }}
      position="right center"
    >
      <div>
        <h1 className="text-center text-xl">
          Log your <span className="text-orange">meal</span>
        </h1>
      </div>
      <div className="flex justify-evenly py-10 px-5 gap-5">
        <Link to={"/mealdiet"}>
          <div className="flex flex-col p-2 text-center shadow-lg gap-2  rounded-2xl">
            <img src={recipebook} className="m-auto" />
            <h1 className="font-bold">Browse app</h1>
            <p className="text-[10px]">
              Find the recipes from the app & log the meals
            </p>
          </div>
        </Link>
        <Link to={"/mealdiet/custom/create/breakfast"}>
          <div className="flex flex-col p-2 text-center shadow-lg gap-2  rounded-2xl">
            <img src={custommeal} className="m-auto" />
            <h1 className="font-bold">Custom meal</h1>
            <p className="text-[10px]">
              Add your own ingredients to log the meals
            </p>
          </div>
        </Link>
      </div>
    </Popup>
  );
};

export default MealLogPopup;
